import React from 'react';
import { MenuButton, Stripe } from './styled';

const Index = (props) => (
    <MenuButton {...props}>
       <Stripe />
    </MenuButton>
);

export default Index;